import React, { useState } from 'react'

import { ReactComponent as IconEdit } from 'assets/images/icons/edit-3.svg'
import FormDrawer from 'components/__new/common/form-drawer'
import CurrencyFormat from 'utils/currencyFormat';
import { ViewPayrollConfigRow } from './ViewPayrollConfigRow';

const ViewAllowanceDetails = (props) => {
    const { isOpen, setIsOpen, allowance, loading, handleEditForm } = props;
    const [isOpenEditAllowance, setIsOpenEditAllowance] = useState(false);
    
    const handleToggleEditModal = () => {
        setIsOpen(false);
        handleEditForm();
    }
    
    return (
        <>
            {/* <EditBenefit
                isOpen={isOpenEditAllowance}
                setIsOpen={setIsOpenEditAllowance}
                allowance={allowance}
            /> */}
            
            <FormDrawer display="center" size="4xl" isOpen={isOpen} setIsOpen={setIsOpen} backdropClickable={false}>
                <div className="p-6">
                    <FormDrawer.Title
                        title="Allowance"
                        // description="Setup a new approval workflow"
                        showCloseButton={true}
                        close={setIsOpen}
                    />
                    <hr className='mt-3'/>

                    <div className="w-full my-7">
                        <div className="my-7 flex items-center justify-end space-x-2 cursor-pointer text-ep-primary-600"
                            onClick={handleToggleEditModal}
                        >
                            <IconEdit />
                            <span className='underline'>Edit Information</span>
                        </div>
                        
                        <div className='p-2 rounded-xl border bg-ep-primary-light-300'>
                            <div className='font-medium text-[#374151] text-lg'>Allowance Information</div>
                            <div className='bg-white mt-4 rounded-2xl p-5 shadow-box-shadow'>
                                <div className='flex flex-col gap-6'>
                                    <ViewPayrollConfigRow 
                                        leftLabel="Name of Allowance"
                                        leftValue={allowance?.name}
                                        leftValueClassName="capitalize"
                                        rightLabel="Allowance Type"
                                        rightValue={allowance?.type?.toLowerCase()}
                                    />
                                    <ViewPayrollConfigRow 
                                        leftLabel="Description"
                                        leftValue={allowance?.description}
                                        leftValueClassName="capitalize"
                                        rightLabel="Rate"
                                        rightValue={`${allowance?.rate_type?.toLowerCase() === "fixed_amount" ? CurrencyFormat(allowance?.value || "-") : allowance?.value} ${allowance?.rate_type?.toLowerCase() === "percentage" ? "%" : ""}`}
                                    />
                                    <ViewPayrollConfigRow 
                                        leftLabel="Rate Source"
                                        leftValue={allowance?.source?.replaceAll("_", " ")?.toLowerCase()}
                                        leftValueClassName="capitalize"
                                        rightLabel="Frequency"
                                        rightValue={allowance?.frequency?.toLowerCase()}
                                    />
                                    <ViewPayrollConfigRow 
                                        leftLabel="Tax Option"
                                        leftValue={allowance?.is_taxable ? "Taxable" : "Not Taxable"}
                                        leftValueClassName="capitalize"
                                        rightLabel="Payslip Settings"
                                        rightValue={allowance?.is_shown_on_payslip ? "Show on Payslips" : "Do not show on Payslips"}
                                    />
                                </div>
                            </div>
                        </div>
                        
                        {/* <div className='my-5 p-2 rounded-xl border bg-ep-primary-light-300'>
                            <div className='font-medium text-[#374151] text-lg'>Others</div>
                            <div className='bg-white mt-4 rounded-2xl p-5 shadow-box-shadow'>
                                    <div className='flex flex-col gap-6'>
                                        <ViewPayrollConfigRow 
                                            leftLabel="Tax Option"
                                            leftValue={allowance?.is_taxable ? "Taxable" : "Not Taxable"}
                                            rightLabel="Payslip Settings"
                                            rightValue={allowance?.is_shown_on_payslip ? "Show on Payslips" : "Do not show on Payslips"}
                                        />
                                    </div>
                            </div>
                        </div> */}
                    </div>
                </div>
            </FormDrawer>
        
        </>
    )
}

export default ViewAllowanceDetails;